module.exports = __webpack_public_path__ + "img/avatar.cdd479f1.jpeg";